export default {
    zh: {
        current_cost: '本次生成消耗',
        discount_percent: `已享会员{discount}折`,
        standard_price: '标准价格',
        vip_has_half_price: '会员立享首单半价',
        start_vip: '开通',
    },
    en: {
        current_cost: 'Cost this time',
        discount_percent: 'VIP discount: {discount}',
        standard_price: 'Standard price',
        vip_has_half_price: 'VIP: 50% off your first order',
        start_vip: 'Upgrade',
    },
    ja: {
        current_cost: '今回の生成コスト',
        discount_percent: '会員割引：{discount}',
        standard_price: '通常価格',
        vip_has_half_price: '会員は初回半額',
        start_vip: 'アップグレード',
    },
    ko: {
        current_cost: '이번 생성 비용',
        discount_percent: 'VIP 할인: {discount}',
        standard_price: '정상가',
        vip_has_half_price: 'VIP 첫 주문 50% 할인',
        start_vip: '업그레이드',
    },
    tw: {
        current_cost: '本次生成消耗',
        discount_percent: '會員折扣：{discount}',
        standard_price: '標準價格',
        vip_has_half_price: '會員立享首單半價',
        start_vip: '升級',
    },
    es: {
        current_cost: 'Costo de esta generación',
        discount_percent: 'Descuento VIP: {discount}',
        standard_price: 'Precio estándar',
        vip_has_half_price: 'VIP: 50% en tu primer pedido',
        start_vip: 'Actualizar',
    },
    fr: {
        current_cost: 'Coût de cette génération',
        discount_percent: 'Remise VIP : {discount}',
        standard_price: 'Prix standard',
        vip_has_half_price: 'VIP : -50% sur votre première commande',
        start_vip: 'Passer VIP',
    },
    de: {
        current_cost: 'Kosten für diese Generierung',
        discount_percent: 'VIP-Rabatt: {discount}',
        standard_price: 'Standardpreis',
        vip_has_half_price: 'VIP: 50% Rabatt auf die erste Bestellung',
        start_vip: 'Upgraden',
    },
    ru: {
        current_cost: 'Стоимость этой генерации',
        discount_percent: 'Скидка VIP: {discount}',
        standard_price: 'Стандартная цена',
        vip_has_half_price: 'VIP: -50% на первый заказ',
        start_vip: 'Оформить VIP',
    },
    pt: {
        current_cost: 'Custo desta geração',
        discount_percent: 'Desconto VIP: {discount}',
        standard_price: 'Preço padrão',
        vip_has_half_price: 'VIP: 50% de desconto no primeiro pedido',
        start_vip: 'Fazer upgrade',
    },
    it: {
        current_cost: 'Costo di questa generazione',
        discount_percent: 'Sconto VIP: {discount}',
        standard_price: 'Prezzo standard',
        vip_has_half_price: 'VIP: 50% sul primo ordine',
        start_vip: 'Upgrade',
    },
    ar: {
        current_cost: 'تكلفة هذه العملية',
        discount_percent: 'خصم VIP: {discount}',
        standard_price: 'السعر القياسي',
        vip_has_half_price: 'VIP: خصم 50% على أول طلب',
        start_vip: 'الترقية',
    },
    th: {
        current_cost: 'ค่าใช้จ่ายการสร้างนี้',
        discount_percent: 'ส่วนลด VIP: {discount}',
        standard_price: 'ราคามาตรฐาน',
        vip_has_half_price: 'VIP: 50% ส่วนลดสำหรับคำสั่งแรก',
        start_vip: 'อัปเกรด',
    },
    da: {
        current_cost: 'Kost for denne generering',
        discount_percent: 'VIP-rabat: {discount}',
        standard_price: 'Standardpris',
        vip_has_half_price: 'VIP: 50% rabat på din første ordre',
        start_vip: 'Opgrader',
    },
    no: {
        current_cost: 'Kost for denne generering',
        discount_percent: 'VIP-rabat: {discount}',
        standard_price: 'Standardpris',
        vip_has_half_price: 'VIP: 50% rabat på din første ordre',
        start_vip: 'Opgrader',
    },
    nl: {
        current_cost: 'Kost voor deze generatie',
        discount_percent: 'VIP-korting: {discount}',
        standard_price: 'Standaardprijs',
        vip_has_half_price: 'VIP: 50% korting op je eerste bestelling',
        start_vip: 'Upgrade',
    },
    id: {
        current_cost: 'Biaya generasi ini',
        discount_percent: 'Diskon VIP: {discount}',
        standard_price: 'Harga standar',
        vip_has_half_price: 'VIP: 50% diskon untuk pesanan pertama',
        start_vip: 'Upgrade',
    },
    tr: {
        current_cost: 'Bu bu generasyon maliyeti',
        discount_percent: 'VIP indirimi: {discount}',
        standard_price: 'Standart fiyat',
        vip_has_half_price: 'VIP: İlk siparişiniz için %50 indirim',
        start_vip: 'Yükselt',
    },
}
